const API = process.env.REACT_APP_BACKEND_URL;

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg.replace(/^Value error, /, '') : JSON.stringify(e))).join(' ');
  if (typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export async function authPost(path, body) {
  const res = await fetch(`${API}/api/auth${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatApiError(data.detail));
  return data;
}
